import styled from '@emotion/styled'
import { Grid as MuiGrid } from '@mui/material'

// Styled Grid component
export const StyledGrid = styled(MuiGrid)`
    margin-bottom: 2rem;
    display: inline-block;
    align-content: left;
    padding: 0;
`
